exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3yZfp {\n  width: 150px;\n  min-height: 150px;\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 10px;\n}\n._3yZfp ._3Phmf,\n._3yZfp .RY1Fx {\n  width: 60px;\n  height: 60px;\n}\n", ""]);

// Exports
exports.locals = {
	"button": "_3yZfp",
	"icon": "_3Phmf",
	"placeholder": "RY1Fx"
};